import { Link } from "react-router-dom";

const NextPage = (props) => {
  if (props.activePage < props.pageCounts) {
    return (
      <li className="next">
        <Link
          to={`?page=${props.activePage + 1}${
            props.tag ? "&tag=" + props.tag : ""
          }`}
        >
          »
        </Link>
      </li>
    );
  } else {
    return (
      <li className="next disabled">
        <span>»</span>
      </li>
    );
  }
};

export default NextPage;
